import { render, staticRenderFns } from "./product_dialog.vue?vue&type=template&id=5099b413&scoped=true"
import script from "./product_dialog.vue?vue&type=script&lang=js"
export * from "./product_dialog.vue?vue&type=script&lang=js"
import style0 from "./product_dialog.vue?vue&type=style&index=0&id=5099b413&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099b413",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5099b413')) {
      api.createRecord('5099b413', component.options)
    } else {
      api.reload('5099b413', component.options)
    }
    module.hot.accept("./product_dialog.vue?vue&type=template&id=5099b413&scoped=true", function () {
      api.rerender('5099b413', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/activity/program_manage/form/components/product_dialog.vue"
export default component.exports